import { FC } from 'react'

import { TagsNoRef } from '@trustycars/genie-ui/types/jsx'
import { propsWithClassNames } from '@trustycars/genie-ui/functions'

import { status } from '@trustycars/genie-ui/style/element'
import { Avatar } from '@trustycars/genie-ui/components'
import { Icon } from '@trustycars/genie-ui/icons'

import {
  container,
  nav,
  name as nameStyle,
  username as usernameStyle,
  aside,
  icon,
  intro
} from './style.css'

export type AccountPreviewProps = {
  name: string
  noAccess?: boolean
  image?: string
  username?: string
  containerProps?: TagsNoRef<'button'>
}

export const AccountPreview: FC<AccountPreviewProps> = ({
  name,
  image,
  noAccess,
  username,
  containerProps
}) => (
  <button type="button" {...propsWithClassNames(containerProps, container)}>
    <Avatar image={{ src: image }} />

    <nav className={nav} hidden>
      <span className={intro}>
        <h4 className={nameStyle}>{name}</h4>
        {noAccess && (
          <span
            className={status({
              size: 'small',
              kind: 'warning',
              type: 'faint'
            })}
            data-testid="noaccess"
          >
            No Access
          </span>
        )}
      </span>

      <p data-testid="username" className={usernameStyle}>
        {username}
      </p>
    </nav>

    <aside className={aside}>
      <Icon namespace="Forward" className={icon} />
    </aside>
  </button>
)

export default AccountPreview
